
import axios from "axios"

export  function getResetPassApi(data) {
  
    const baseUrl = process.env.REACT_APP_BASE_URL_ONE;

	return axios
		.post(baseUrl+"api/v1/users/settings/set-new-password/", data)
		.then( (res)=> {
			
			return res
		})
		.catch((err) => {
          
			return err
          
		})
  
}
